import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Bankselfiedetails(state = initialState, action) {
  switch (action.type) {
    case userConstants.BANKSELFIE_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.BANKSELFIE_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.BANKSELFIE_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}